module.exports = __webpack_public_path__ + "static/media/tablet_advertising.db7944af.svg";